import React, { useState, useEffect } from 'react';
import {
    makeStyles,
    createStyles,
    withStyles,
    WithStyles,
} from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';

import {
    List,
    ListItem,
    ListItemText,
    IconButton,
    Typography,
    Grid,
    Divider,
    Button,
    Box,
    Card,
    CardActions,
    CardContent,
} from '@material-ui/core';
import NumberFormat from 'react-number-format';

import { Link, useHistory } from 'react-router-dom';

import { COLORS } from './Theme';
import { SIcon } from './Icon';

// import { getMember, makeURL } from '../request/request'
import axios from 'axios';

import { member as v_member, basic } from '../request/values';

const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
    card: {
        background: `url("/images/info_box.png")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'inherit',
        backgroundSize: 'contain',
        // width : 375,
        // height: 255,

        width: '100%',
        height: '63vw',
        maxHeight: '450px',
        // marginLeft: '2.9vw',
        // marginRight: '1.1vw',

        // padding: "4vh 6.5vw 0",
        // color: '#ffffff',
        border: 'none',
        boxShadow: 'none',
        maxWidth: '700px',
        '& #companyName': {
            marginTop: '3%',
            color: `${COLORS.WATER_BLUE}`,
            [theme.breakpoints.up('md')]: {
                marginTop: '10%',
            },
        },
        '& #stock': {
            // marginTop: '2.5%',
            color: `${COLORS.WATER_BLUE}`,
        },
        '& #unit': {
            ...theme.typography.h4,
            color: `${COLORS.WATER_BLUE}`,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
        },
    },
    cardContent: {
        margin: '0',
        padding: '11% 7% 0',
    },
    loanButton: {
        width: '30%',
        float: 'right',
        marginTop: '7%',
        borderRadius: '8px',
        backgroundColor: `${COLORS.WHITE}`,
        [theme.breakpoints.up('lg')]: {
            marginTop: '13%',
        },
    },
    loadButtonText: {
        color: `${COLORS.WATER_BLUE}`,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
    },
    questButton: {
        width: '30%',
        float: 'left',
        marginTop: '7%',
        borderRadius: '8px',
        backgroundColor: `${COLORS.WHITE}`,
        [theme.breakpoints.up('lg')]: {
            marginTop: '13%',
        },
    },
    assetButton: {
        width: '30%',
        float: 'right',
        borderRadius: '8px',
        backgroundColor: `${COLORS.WHITE}`,
    },

    memberButton: {
        borderRadius: '8px',
        backgroundColor: `${COLORS.WATER_BLUE}`,
    },
    memberButtonText: {
        color: `${COLORS.WHITE}`,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
    },

    controlBar: {},
    button: {
        height: 60,
        margin: theme.spacing(3, 0, 2),
        borderRadius: '27px',
        boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: 'solid 0.5px #cfd4d9',
        backgroundColor: `${COLORS.PUMPKIN}`,
    },
    buttonText: {
        color: `${COLORS.WHITE}`,
        fontFamily: 'NanumB',
        marginLeft: '2vw',
    },
    teamBox: {
        width: '100%',
        // marginLeft: '2vw',
        // marginRight: '2vw',
        marginTop: 20,
    },
    list: {
        paddingTop: '1.5vh',
    },

    teamList: {
        backgroundColor: `${COLORS.LIGHT_GREY}`,
        marginBottom: '1vh',
        '& #teamName > span': {
            ...theme.typography.h3,
            color: `${COLORS.CHARCOAL_GREY}`,
            fontFamily: 'NanumB',
        },
    },

    teamListPosition: {
        marginRight: 'auto',
        '& span': {
            ...theme.typography.h3,
            color: `${COLORS.CHARCOAL_GREY}`,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
        },
    },

    bigTitle: {
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        fontSize: '8vw',
        '@media (min-width:748px)': {
            fontSize: '42px',
        },
    },
    teamListName: {
        align: 'right',
    },
    buttonBox: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    cashButton: {
        ...theme.typography.h3,
        color: `${COLORS.WATER_BLUE}`,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
    },
    teamStatus: {
        ...theme.typography.h2,
        fontWeight: 'bold',
    },
}));

const CompanyInfo: React.FC<any> = (props) => {
    const classes = useStyles();
    let history = useHistory();

    const { member } = props;

    const [stock, setStock] = useState<number>(0);
    const [memberList, setMemberList] = useState([]);
    const [companyName, setCompanyName] = useState([]);

    const [ceo, setCEO] = useState({ id: '', name: '' });
    const [sale, setSale] = useState('');
    const [production, setProduction] = useState('');
    const [purchase, setPurchase] = useState('');

    let grade = [''];
    if (member.companyType == 'D') {
        grade = ['대표', '구매담당자', '판매담당자', '분해담당자'];
    } else if (member.companyType == 'S') {
        grade = ['대표', '구매 및 수익창출담당자', '분해담당자', '판매담당자'];
    } else if (member.companyType == 'M') {
        grade = ['대표', '구매담당자', '판매담당자', '생산담당자'];
    }

    const getCompanyInfo = () => {
        let url = new URL(
            basic.server + v_member.member + v_member.company_info
        );
        let params = { companyNum: member.companyNum };
        url.search = new URLSearchParams(params).toString();
        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data) => {
                console.log(data);
                // this.setState({
                //     companyName: data.company.companyName,
                //     companyStock: data.company.companyStock,
                //     memberList: data.company.employees,
                // })
                setCompanyName(data.company.companyName);
                setStock(data.company.companyStock);
                console.log(data.company.companyType);
                if (data.company.companyType == 'M')
                    renderMemberListM(data.company.employees);
                else if (data.company.companyType == 'D')
                    renderMemberListD(data.company.employees);
                else if (data.company.companyType == 'S')
                    renderMemberListS(data.company.employees);
                setMemberList(data.company.employees);
            });
    };

    const renderMemberListM = async (members: any) => {
        let tPurchase = '',
            tSale = '',
            tProduction = '',
            tCEO: any;

        for await (let member of members) {
            if (member.grade === 'CEO') {
                tCEO = { name: member.memberName, id: member.memberEmail };
            } else if (member.grade === '구매담당자') {
                if (tPurchase === '') {
                    tPurchase = member.memberName;
                } else {
                    tPurchase = tPurchase.concat('\n' + member.memberName);
                }
            } else if (member.grade === '생산담당자') {
                if (tProduction === '') {
                    tProduction = member.memberName;
                } else {
                    tProduction = tProduction.concat('\n' + member.memberName);
                }
            } else if (member.grade === '판매담당자') {
                if (tSale === '') {
                    tSale = member.memberName;
                } else {
                    tSale = tSale.concat('\n' + member.memberName);
                }
            }
        }

        setCEO(tCEO);
        setProduction(tProduction);
        setSale(tSale);
        setPurchase(tPurchase);
    };

    const renderMemberListD = async (members: any) => {
        let tPurchase = '',
            tSale = '',
            tSale2 = '',
            tProduction = '',
            tCEO: any;

        for await (let member of members) {
            if (member.grade === 'CEO') {
                tCEO = { name: member.memberName, id: member.memberEmail };
            } else if (member.grade === '구매담당자') {
                if (tPurchase === '') {
                    tPurchase = member.memberName;
                } else {
                    tPurchase = tPurchase.concat('\n' + member.memberName);
                }
            } else if (member.grade === '판매담당자') {
                if (tSale === '') {
                    tSale = member.memberName;
                } else {
                    tSale = tSale.concat('\n' + member.memberName);
                }
            } else if (member.grade === '분해담당자') {
                if (tProduction === '') {
                    tProduction = member.memberName;
                } else {
                    tProduction = tProduction.concat('\n' + member.memberName);
                }
            }
        }

        setCEO(tCEO);
        setSale(tSale);
        setPurchase(tPurchase);
        setProduction(tProduction);
    };

    const renderMemberListS = async (members: any) => {
        let tPurchase = '',
            tSale = '',
            tProduction = '',
            tCEO: any;

        for await (let member of members) {
            if (member.grade === 'CEO') {
                tCEO = { name: member.memberName, id: member.memberEmail };
            } else if (member.grade === '구매 및 수익창출담당자') {
                if (tPurchase === '') {
                    tPurchase = member.memberName;
                } else {
                    tPurchase = tPurchase.concat('\n' + member.memberName);
                }
            } else if (member.grade === '분해담당자') {
                if (tProduction === '') {
                    tProduction = member.memberName;
                } else {
                    tProduction = tProduction.concat('\n' + member.memberName);
                }
            } else if (member.grade === '판매담당자') {
                if (tSale === '') {
                    tSale = member.memberName;
                } else {
                    tSale = tSale.concat('\n' + member.memberName);
                }
            }
        }

        setCEO(tCEO);
        setProduction(tProduction);
        setSale(tSale);
        setPurchase(tPurchase);
    };

    const goLoan = () => {
        history.push('/LoanList');
    };

    const goQuest = () => {
        history.push('/QuestList');
    };

    const goAsset = () => {
        history.push('/CompanyAsset');
    };

    useEffect(() => {
        console.log('in effect');
        getCompanyInfo();
    }, []);

    return (
        <div className="contentCompanyInfo" translate="no">
            <Card className={classes.card}>
                <CardContent className={classes.cardContent}>
                    <div className={classes.buttonBox}>
                        <Typography className={classes.cashButton}>
                            현금 자산
                        </Typography>
                        <Button
                            className={classes.assetButton}
                            onClick={() => goAsset()}
                        >
                            <Typography
                                variant="h3"
                                className={classes.loadButtonText}
                            >
                                재무현황
                            </Typography>
                        </Button>
                    </div>
                    <Typography
                        variant="subtitle1"
                        align="center"
                        id="companyName"
                    >
                        {companyName}
                    </Typography>
                    <p style={{ textAlign: 'center', margin: 0 }}>
                        <span id="stock" className={classes.bigTitle}>
                            <NumberFormat
                                value={stock}
                                displayType={'text'}
                                thousandSeparator={true}
                            />
                        </span>
                        <span id="unit">원</span>
                    </p>
                    {/* {member.companyType === 'D' && (
                        <Button
                            className={classes.questButton}
                            onClick={() => goQuest()}
                        >
                            <Typography
                                variant="h3"
                                className={classes.loadButtonText}
                            >
                                {member.classVersion === 4
                                    ? '판매임무'
                                    : '분해임무'}
                            </Typography>
                        </Button>
                    )} */}
                    {member.id === ceo.id && (
                        <Button
                            className={classes.loanButton}
                            onClick={() => goLoan()}
                        >
                            <Typography
                                variant="h3"
                                className={classes.loadButtonText}
                            >
                                은행
                            </Typography>
                        </Button>
                    )}
                </CardContent>
            </Card>

            <div className={classes.teamBox}>
                <div
                    style={{
                        justifyContent: 'space-between',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <Typography className={classes.teamStatus}>
                        팀원 현황
                    </Typography>
                    {member.id === ceo.id && (
                        <Link
                            to="/CompanyAppList"
                            style={{ textDecoration: 'none' }}
                        >
                            <Button className={classes.memberButton}>
                                <Typography
                                    variant="h3"
                                    className={classes.memberButtonText}
                                >
                                    팀원 추가하기
                                </Typography>
                            </Button>
                        </Link>
                    )}
                </div>

                <List className={classes.list}>
                    <ListItem
                        alignItems="flex-start"
                        className={classes.teamList}
                    >
                        <ListItemText
                            className={classes.teamListPosition}
                            primary={grade[0]}
                        ></ListItemText>
                        <ListItemText
                            id="teamName"
                            primaryTypographyProps={{
                                align: 'right',
                            }} /*primary={CEO}*/
                        >
                            {ceo !== undefined && ceo.name}
                        </ListItemText>
                    </ListItem>
                    <Divider />

                    <ListItem
                        alignItems="flex-start"
                        className={classes.teamList}
                    >
                        <ListItemText
                            className={classes.teamListPosition}
                            primary={grade[1]}
                        ></ListItemText>
                        <ListItemText
                            id="teamName"
                            primaryTypographyProps={{
                                align: 'right',
                            }} /*primary={purchase}*/
                        >
                            {purchase.split('\n').map((line: any) => {
                                return (
                                    <span>
                                        {line}
                                        <br />
                                    </span>
                                );
                            })}
                        </ListItemText>
                    </ListItem>
                    <Divider />

                    <ListItem
                        alignItems="flex-start"
                        className={classes.teamList}
                    >
                        <ListItemText
                            className={classes.teamListPosition}
                            primary={grade[2]}
                        ></ListItemText>
                        <ListItemText
                            id="teamName"
                            primaryTypographyProps={{
                                align: 'right',
                            }} /*primary={sale}*/
                        >
                            {sale.split('\n').map((line: any) => {
                                return (
                                    <span>
                                        {line}
                                        <br />
                                    </span>
                                );
                            })}
                        </ListItemText>
                    </ListItem>
                    <Divider />

                    <ListItem
                        alignItems="flex-start"
                        className={classes.teamList}
                    >
                        <ListItemText
                            className={classes.teamListPosition}
                            primary={grade[3]}
                        ></ListItemText>
                        {member.companyType == 'D' && (
                            <ListItemText
                                id="teamName"
                                primaryTypographyProps={{
                                    align: 'right',
                                }} /*primary={sale}*/
                            >
                                {production.split('\n').map((line: any) => {
                                    return (
                                        <span>
                                            {line}
                                            <br />
                                        </span>
                                    );
                                })}
                            </ListItemText>
                        )}
                        {member.companyType != 'D' && (
                            <ListItemText
                                id="teamName"
                                primaryTypographyProps={{
                                    align: 'right',
                                }} /*primary={production}*/
                            >
                                {production.split('\n').map((line: any) => {
                                    return (
                                        <span>
                                            {line}
                                            <br />
                                        </span>
                                    );
                                })}
                            </ListItemText>
                        )}
                    </ListItem>
                    <Divider />
                </List>
            </div>

            {/* <Link to="/CompanyAppList" style={{ textDecoration: 'none' }}>
                <Button
                    fullWidth
                    className={classes.button}
                    style={{ backgroundColor: `${COLORS.WATER_BLUE}` }}
                // onClick={handleButton}
                >
                    <SIcon type="Profile" />
                    <Typography variant="h3" className={classes.buttonText}>
                        팀원 추가하기
                    </Typography>
                </Button>
            </Link> */}
            {/* <Link component={Button} to="/loanList">대출하기</Link> */}

            {/* <LoanListModal></LoanListModal> */}
        </div>
    );
};

export default CompanyInfo;

// class CompanyInfo extends React.Component<CompanyInfoProps, CompanyInfoState> {
//     constructor(props: CompanyInfoProps) {
//         super(props)
//         this.state = {
//             companyName: "",
//             companyStock: 0,
//             memberList: [],
//             grade: ["CEO", "구매담당자", "생산담당자", "판매담당자"]
//         }
//     }

//     callAPI() {
//         // const memberString:any = localStorage.getItem('member')
//         // const member:any = memberString ? JSON.parse(memberString) : null;

//         const member = getMember();
//         // const url = makeURL("http://localhost:3001/v3/member/company/info", { 'companyNum': member.companyNum })

//         let url = new URL(basic.server + v_member.member + v_member.company_info);
//         let params = { 'companyNum': member.companyNum }
//         url.search = new URLSearchParams(params).toString();

//         console.log(url)
//         console.log(url.toString())

//         // fetch(url.toString(),{credentials: "include",})
//         axios({
//             method: "GET",
//             withCredentials: true,
//             url: url.toString(),
//         })
//             .then((res) => res.data)
//             .then((data) => {
//                 this.setState({
//                     companyName: data.company.companyName,
//                     companyStock: data.company.companyStock,
//                     memberList: data.company.employees,
//                 })
//             })
//     }

//     componentDidMount() {
//         this.callAPI()
//     }

//     renderMemberList(members: Array<iMember>) {
//         let CEO: string = "", sale: string = "", production: string = "", purchase: string = "";

//         for (let member of members) {
//             if (member.grade == 'CEO') {
//                 CEO = member.memberName;
//             } else if (member.grade == '구매담당자') {
//                 purchase = member.memberName;
//             } else if (member.grade == '생산담당자') {
//                 production = member.memberName;
//             } else if (member.grade == '판매담당자') {
//                 sale = member.memberName;
//             }
//         }

//         return { CEO, purchase, production, sale };

//     }

//     render() {
//         const { classes, member } = this.props;
//         const { companyName, companyStock, memberList, grade } = this.state;
//         const { CEO, purchase, production, sale } = this.renderMemberList(memberList)
//         return (
//             <div>
//                 <Card className={classes.card}>
//                     <CardContent>
//                         <Grid container justify="space-between" className={classes.controlBar}>
//                             <Grid>
//                                 <Typography variant="h3" style={{ color: `${COLORS.WATER_BLUE}` }}>
//                                     현재 금액
//                                 </Typography>
//                             </Grid>
//                             <Grid>
//                                 <IconButton onClick={setting} style={{ padding: 0 }}>
//                                     <SIcon type="Refresh" />
//                                 </IconButton>
//                             </Grid>
//                         </Grid>

//                         <Box mt={2}>
//                             <Typography align="center">{companyName}</Typography>
//                             <Typography align="center">
//                                 <NumberFormat value={companyStock} displayType={'text'} thousandSeparator={true} suffix={'원'} />
//                             </Typography>
//                         </Box>

//                     </CardContent>
//                     <CardActions>
//                         <Link className={classes.loanButton} to="/loanList"><Button size="small">대출하기</Button></Link>
//                     </CardActions>
//                 </Card>
//                 <div className={classes.teamBox}>
//                     <Typography>
//                         팀원 현황
//                     </Typography>
//                     <List>
//                         <ListItem alignItems="flex-start">
//                             <ListItemText className={classes.teamListPosition} primary={grade[0]}></ListItemText>
//                             <ListItemText primaryTypographyProps={{ align: "right" }} primary={CEO}></ListItemText>
//                         </ListItem>
//                         <Divider />

//                         <ListItem alignItems="flex-start">
//                             <ListItemText className={classes.teamListPosition} primary={grade[1]}></ListItemText>
//                             <ListItemText primaryTypographyProps={{ align: "right" }} primary={purchase}></ListItemText>
//                         </ListItem>
//                         <Divider />

//                         <ListItem alignItems="flex-start">
//                             <ListItemText className={classes.teamListPosition} primary={grade[2]}></ListItemText>
//                             <ListItemText primaryTypographyProps={{ align: "right" }} primary={production}></ListItemText>
//                         </ListItem>
//                         <Divider />

//                         <ListItem alignItems="flex-start">
//                             <ListItemText className={classes.teamListPosition} primary={grade[3]}></ListItemText>
//                             <ListItemText primaryTypographyProps={{ align: "right" }} primary={sale}></ListItemText>
//                         </ListItem>
//                     </List>
//                 </div>
//                 {/* <Link component={Button} to="/loanList">대출하기</Link> */}

//                 {/* <LoanListModal></LoanListModal> */}
//             </div>

//         )
//     }
// }

type MoneyBoardProps = {
    companyName: string;
    money: number;
    theme?: any;
};

class MoneyBoard extends React.Component<MoneyBoardProps> {
    constructor(props: MoneyBoardProps) {
        super(props);
        this.state = {};
    }

    render() {
        // withStyles(styles)
        // const {root, title} = styles;
        const { companyName, money, theme } = this.props;
        return (
            <>
                <Card className={theme.card}>
                    <CardContent>
                        <Typography>현재 금액</Typography>
                        <Typography align="center">{companyName}</Typography>
                        <Typography align="center">{money}</Typography>
                    </CardContent>
                    <CardActions>
                        <Button className={theme.loadButton} size="small">
                            대출하기
                        </Button>
                    </CardActions>
                </Card>
            </>
        );
    }
}

const SimpleCard = withStyles((theme: Theme) => ({
    root: {
        backgroundColor: '#1488ca',
        maxWidth: 345,
        minWidth: 100,
        marginTop: 10,
        justifyContent: 'center',
    },
}))(Card);

const ColorButton = withStyles((theme: Theme) => ({
    root: {
        color: '#ffffff',
        backgroundColor: '#1488ca',
        '&:hover': {
            backgroundColor: '#1488aa',
        },
        marginLeft: 'auto',
    },
}))(Button);

// export default withStyles(useStyles)(CompanyInfo);
